import React, { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { openInput } from '../../../actions/baseActions';

type AirportSelectSearchInputProps = {
	selected: string;
	name: string;
	placeholder?: string;
	onChange: (keyword: string) => void;
	openInput: (name?: string) => void;
};
type AirportSelectSearchInputState = {
	keyword: string;
};

class AirportSelectSearchInput extends React.Component<AirportSelectSearchInputProps, AirportSelectSearchInputState> {
	constructor(props: AirportSelectSearchInputProps) {
		super(props);
		this.state = {
			keyword: '',
		};
	}

	click = (ev: MouseEvent) => {
		const el = ev.currentTarget as HTMLInputElement;
		if (document.activeElement !== el && el) {
			setTimeout(() => {
				el.select();
			}, 0);
		}
	};
	onChange = (e: ChangeEvent<HTMLInputElement>) => {
		this.setState(
			{
				keyword: e.target.value,
			},
			() => {
				this.props.onChange(this.state.keyword);
			}
		);
	};

	componentDidUpdate(prevProps: AirportSelectSearchInputProps) {
		const oldSelected = prevProps.selected;
		const selected = this.props.selected || '';
		if (selected !== oldSelected) {
			this.setState({
				keyword: selected,
			});
		}
	}

	render() {
		const { placeholder, name } = this.props;
		const keyword = this.state.keyword;
		return (
			<input
				onClick={() => this.props.openInput(name)}
				id={`${name}-input`}
				name={`${name}-input`}
				autoComplete="off"
				data-hj-allow
				// @ts-ignore
				onMouseDown={this.click}
				onChange={this.onChange}
				placeholder={placeholder}
				value={keyword !== null ? keyword : ''}
				type="text"
				className="form-control"
			/>
		);
	}
}

export default connect(null, { openInput })(AirportSelectSearchInput);
